export const GET_CUSTOMER_AND_OTHER_INFORMATION =  'GET_CUSTOMER_AND_OTHER_INFORMATION';
export const CALCULATE_DISCOUNT_AND_TAX  =  'CALCULATE_DISCOUNT_AND_TAX';
export const UPDATE_APP_VIEW  =  'UPDATE_APP_VIEW';

export const GET_CUSTOMER_DETAIL_WITH_ID  =  'GET_CUSTOMER_DETAIL_WITH_ID';
export const GET_PREVIOUS_ADDRESSES_WITH_ID  =  'GET_PREVIOUS_ADDRESSES_WITH_ID';
export const UPDATE_PLATFORM  =  'UPDATE_PLATFORM';

export const APPLY_PROMO_CODE  =  'APPLY_PROMO_CODE';

export const CREDIT_CARD_CHECK = 'CREDIT_CARD_CHECK';
